tinymce.init({
    paste_as_text: true,
    menubar : false,
    selector: ".editor",
    plugins: "link code",
    toolbar1: "undo redo | formatselect variables | bold italic underline | alignleft alignright aligncenter alignjustify | bullist numlist | link | removeformat | code",
    setup: function(editor) {
		editor.on('PreInit', function() {
			// Create a custom node filter to remove unwanted content when getting content from the editor
			editor.serializer.addNodeFilter('div', function(nodes) {
				nodes.forEach(function(node) {
					var id = node.attr('id');
					if (id === 'ConnectiveDocSignExtentionInstalled') {
						node.remove();
					}
				});
			});
		});
	},
    relative_urls : false,
    remove_script_host : false,
    document_base_url: '/',
    convert_urls : true,
    table_default_styles: {
        width: '100%'
    },
    fontsize_formats: "4pt 6pt 8pt 10pt 12pt 14pt 18pt 24pt 36pt",
    height: "20vh",
});
